import React from 'react';
import { Search } from '../../../bravosIcons';
import type { LibraryWorkoutPlansApi } from '../../hooks/useLibraryWorkoutPlans';

type WorkoutPlansSearchMobileProps = {
  pl: LibraryWorkoutPlansApi;
};

/** Mobile Library — Workout Plans tab search row (R8). */
export function WorkoutPlansSearchMobile({ pl }: WorkoutPlansSearchMobileProps) {
  return (
    <div className="py-3">
      <div className="relative max-w-md">
        <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 dark:text-theme-off-white/40" />
        <input
          type="text"
          value={pl.workoutPlanNameFilter}
          onChange={(e) => pl.setWorkoutPlanNameFilter(e.target.value)}
          placeholder="Search workout plan name"
          className="h-11 w-full rounded-2xl border border-slate-200 bg-white pl-11 pr-4 text-sm text-slate-700 placeholder:text-slate-400 shadow-sm transition focus:border-slate-300 focus:outline-none focus:ring-4 focus:ring-slate-200/70 dark:border-white/10 dark:bg-theme-surface dark:text-theme-off-white dark:placeholder:text-theme-off-white/40 dark:focus:border-white/20 dark:focus:ring-white/10"
        />
      </div>
    </div>
  );
}
